import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key)
    }
  });
  return messages
}

const numberFormats = {
  'it-IT': {
    currency: {
      style: 'currency', currency: 'EUR'
    },
    decimal: {
      style: 'decimal'
    },
    percent: {
      style: 'percent'
    }
  },
  'en-US': {
    currency: {
      style: 'currency', currency: 'USD'
    },
    decimal: {
      style: 'decimal'
    },
    percent: {
      style: 'percent'
    }
  }
};

const dateTimeFormats = {
  'it-IT': {
    short: {
      day: '2-digit', month: '2-digit', year: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: '2-digit',
      weekday: 'short', hour: 'numeric', minute: 'numeric'
    }
  },
  'en-US': {
    short: {
      day: '2-digit', month: '2-digit', year: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: '2-digit',
      weekday: 'short', hour: 'numeric', minute: 'numeric'
    }
  }
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'it-IT',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'it-IT',
  messages: loadLocaleMessages(),
  numberFormats: numberFormats,
  dateTimeFormats: dateTimeFormats
})
